import * as React from 'react';
import { Modal } from 'antd';

import { eventBus } from '@/service/event-bus';
import CloseIcon from '@/assets/svg/close-circle.svg';
import { PayCards } from '@/components/PaidModal/PayCards';

import styles from './styles.module.less';

const PaidModal = () => {
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    const handleOpen = () => {
      setOpen(true);
    };

    eventBus.on('NEED_PAID_MODAL', handleOpen);
    return () => {
      eventBus.off('NEED_PAID_MODAL', handleOpen);
    };
  }, []);

  return (
    <Modal
      className={styles.modal}
      title={null}
      closeIcon={null}
      open={open}
      footer={null}
      width={800}
      getContainer={() => document.body}
    >
      <CloseIcon onClick={() => setOpen(false)} className={styles.closeIcon} />
      <div className={styles.payCardsWrapper}>
        <PayCards showFreeCard={false} showMessage />
      </div>
    </Modal>
  );
};

export default PaidModal;
